const MOBILE_SEARCH_PAGE_BANNER_STEP = 5;
const DESKTOP_SEARCH_PAGE_BANNER_STEP = 3;

export {
    MOBILE_SEARCH_PAGE_BANNER_STEP,
    DESKTOP_SEARCH_PAGE_BANNER_STEP,
};